import { AccordionItemStyled } from 'modules/mainmenu/responses/styles'
import { AccordionItemButton, AccordionItemHeading, AccordionItemPanel, AccordionItemState } from 'react-accessible-accordion'
import { ReactComponent as ExpandedOff } from 'assets/images/icons/expander_off.svg'
import { ReactComponent as ExpandedOn } from 'assets/images/icons/expander_on.svg'
import { ReactComponent as PrivateIcon } from 'assets/images/icons/private.svg'
import { EmptyListCreateDraft } from './EmptyListCreateDraft'
import PagesList from './PagesList'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'

export function Private(props) {
  const { state_uncategorized_private_contents, searchText } = props

  const { pathname } = useLocation();

  const getCurrentCategoryFromUrl = () => {
    const urlToArray = pathname?.split('/');
    return urlToArray[urlToArray.length - 1]
  }

  return (
    <AccordionItemStyled uuid={`private`} className={`categorySection accordionItem`} level={0}>
      <AccordionItemHeading className='accordionItemHeading'>
        <AccordionItemButton className='accordionItemButton d-flex justify-content-between'>
          <div className='categoryName-wrapper'>
            <AccordionItemState>
              {({ expanded }) =>
                expanded ? (
                  <div className='expandButton expanded'>
                    <ExpandedOn />
                  </div>
                ) : (
                  <div className='expandButton'>
                    <ExpandedOff />
                  </div>
                )
              }
            </AccordionItemState>
            <span className={`categoryName ml-1 mr-3 ${'private' === getCurrentCategoryFromUrl() ? 'active' : ''}`} onClick={(e) => e.stopPropagation()}>
              <PrivateIcon />
              <Link to={`/page/category/private`}>
                <span className='ml-2'>Private</span>
              </Link>
            </span>
          </div>
        </AccordionItemButton>
      </AccordionItemHeading>

      <AccordionItemPanel className={`AccordionItemPanel pages`}>
        {state_uncategorized_private_contents && state_uncategorized_private_contents.length > 0 && (
          <PagesList showMovetocategory={true} section='private' pages={state_uncategorized_private_contents} level={1} />
        )}
        {!searchText && <EmptyListCreateDraft type='page' level={1} category={{ contents: state_uncategorized_private_contents }} />}
      </AccordionItemPanel>
    </AccordionItemStyled>
  )
}

const mapDispatchToProps = () => ({})
const mapStateToProps = (state) => ({
  selectedPageOrDraft: state.contents.selectedPageOrDraft
})
export default connect(mapStateToProps, mapDispatchToProps)(Private)
